// Presigned S3 URLs regenerate on every dashboard poll (new signature each
// time), which makes the browser treat the image as new and re-download it —
// the captures visibly re-flash every 60s. We pin the first URL we see per
// capture id and keep returning it, so the image element's src never changes
// on a metadata refresh and the browser keeps the already-decoded image.
//
// Backend signs URLs for 7 days, so a pinned URL stays valid well beyond any
// realistic refresh window. We still re-pin after 6 days as a safety margin
// for an always-on wall.

const MAX_AGE_MS = 6 * 86_400_000;

interface Pinned {
  url: string;
  pinnedAt: number;
}

const cache = new Map<string, Pinned>();

export function stableImageUrl(id: string, url: string | null | undefined): string | null {
  const now = Date.now();
  const existing = cache.get(id);
  if (existing && now - existing.pinnedAt < MAX_AGE_MS) {
    return existing.url;
  }
  if (url) {
    cache.set(id, { url, pinnedAt: now });
    return url;
  }
  return existing?.url ?? null;
}
